// extracted by mini-css-extract-plugin
export default {"svgTimer":"SvgTimer_svgTimer__WmCRl"};